var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-toggle',_vm._g(_vm._b({staticClass:"tes-toggle",model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'q-toggle',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }